import { render } from "./ListPriceRequestsActionButtonsRenderer.vue?vue&type=template&id=590a782a"
import script from "./ListPriceRequestsActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListPriceRequestsActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__